import { useEffect, useRef, useState } from "react"
import * as echarts from "echarts"
import PageHeader from "../../components/PageHeader"
import "../../style/card-animate.css"
import { JobActivityStatCard } from "../../components/institute/dashboard/InstituteStatCard"
import NoDataFound from "../../components/NoDataFound"
import { LMSBASEURL } from "../../config/apiUrls"
import { useNavigate } from "react-router-dom"

export default function Component() {
    const chartRef = useRef(null)
    const [dashboardData, setDashboardData] = useState(null)
    const [loading,setLoading] = useState(false)
    const instituteId = sessionStorage.getItem("instituteId");
    const token = process.env.REACT_APP_API_TOKEN;
    const navigate = useNavigate()

    useEffect(() => {
        setLoading(true)
        const raw = JSON.stringify({ institute_id: instituteId })

        fetch(`${LMSBASEURL}/api/job-activity`, {
            method: "POST",
            headers: {
                "Authorization": token,
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: raw,
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.success) {
                    const data = result.data
                    setDashboardData({
                        totalJobsPosted: data.totalJobsPosted,
                        totalStudents:data?.total_students || data?.totalStudents,
                        totalCompaniesAdded: data.totalCompaniesAdded,
                        totalApplicationsReceived: data.totalApplicationsReceived,
                        applicationTrend: {
                            title: {
                                text: "Monthly Application & Job Posting Trends",
                                left: "center",
                                textStyle: {
                                    fontSize: 16,
                                    fontWeight: "bold",
                                },
                            },
                            tooltip: {
                                trigger: "axis",
                                axisPointer: {
                                    type: "cross",
                                    label: { backgroundColor: "#6a7985" },
                                },
                            },
                            legend: {
                                data: ["Applications Received", "Jobs Posted"],
                                top: 30,
                            },
                            grid: {
                                left: "3%",
                                right: "4%",
                                bottom: "3%",
                                top: "15%",
                                containLabel: true,
                            },
                            xAxis: {
                                type: "category",
                                boundaryGap: false,
                                data: data.graphData.month,
                            },
                            yAxis: { type: "value" },
                            series: [
                                {
                                    name: "Applications Received",
                                    type: "line",
                                    stack: "Total",
                                    areaStyle: { opacity: 0.3 },
                                    emphasis: { focus: "series" },
                                    data: data.graphData.jobreceived,
                                    itemStyle: { color: "#007bff" },
                                    lineStyle: { color: "#007bff" },
                                },
                                {
                                    name: "Jobs Posted",
                                    type: "line",
                                    stack: "Total",
                                    areaStyle: { opacity: 0.3 },
                                    emphasis: { focus: "series" },
                                    data: data.graphData.jobposted,
                                    itemStyle: { color: "#28a745" },
                                    lineStyle: { color: "#28a745" },
                                },
                            ],
                        },
                    })
                }
            })
            .catch((err) => console.error("Error fetching job activity:", err))
            .finally(()=>{
                setLoading(false)
            })
    }, [])

    useEffect(() => {
        if (!dashboardData || !chartRef.current) return

        const chartInstance = echarts.init(chartRef.current)
        chartInstance.setOption(dashboardData.applicationTrend)

        const resizeObserver = new ResizeObserver(() => {
            chartInstance.resize()
        })
        resizeObserver.observe(chartRef.current)

        return () => {
            chartInstance.dispose()
            if (chartRef.current) resizeObserver.unobserve(chartRef.current)
        }
    }, [dashboardData])

    return (
        <>
            {/* <PageHeader
                title="Job Activity"
                breadcrumbs={[
                    { label: "Dashboard", path: "/institute-dashboard" },
                    { label: "Job Activity", active: true },
                ]}
            /> */}

            {loading ? (
                <div className="py-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="row mb-4">
                        <JobActivityStatCard
                            title="Total Students" 
                            value={dashboardData?.totalStudents || 0} 
                            icon="ri-group-line"
                            url='/import-students-list'
                            // onClick={() => navigate('/job-page', { replace: true })}
                            style={{ cursor: 'pointer' }}
                        />
                        <JobActivityStatCard
                            title="Total Jobs Posted" 
                            value={dashboardData?.totalJobsPosted || 0} 
                            icon="ri-upload-line"
                            url='/job-page'
                            // onClick={() => navigate('/job-page', { replace: true })}
                            style={{ cursor: 'pointer' }}
                        />
                        <JobActivityStatCard
                            title="Total Companies Added" 
                            value={dashboardData?.totalCompaniesAdded || 0} 
                            icon="ri-add-box-line"
                            url='/company-list'
                            // onClick={() => navigate('/company-list', { replace: true })}
                            style={{ cursor: 'pointer' }}
                        />
                        <JobActivityStatCard
                            title="Total Application Received" 
                            value={dashboardData?.totalApplicationsReceived || 0} 
                            icon="ri-user-received-line"
                            url='/student-application'
                            // onClick={() => navigate('/student-application', { replace: true })}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    {!dashboardData ? <NoDataFound message="No Graph data found" className="border rounded-4"/>:
                    <div className="row">
                        <div className="col-12">
                            <div className="card border">
                                <div className="card-header bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="card-title mb-1">Application Insights</h5>
                                            <p className="text-muted small mb-0">
                                                Monthly trends for applications and job postings
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div style={{ height: "400px" }}>
                                        <div ref={chartRef} style={{ width: "100%", height: "100%" }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            )}
        </>
    )
}

